

























































import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { QrcodeIcon, CloseIcon, ChevronRightIcon } from 'tdesign-icons-vue';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';

// 图标
import approve from '@/renderer/assets/images/Icon/svg/industryInfo/approve.svg';
import approved from '@/renderer/assets/images/Icon/svg/industryInfo/approved.svg';
import book from '@/renderer/assets/images/Icon/svg/industryInfo/book.svg';
import booked from '@/renderer/assets/images/Icon/svg/industryInfo/booked.svg';
import collect from '@/renderer/assets/images/Icon/svg/industryInfo/collect.svg';
import collected from '@/renderer/assets/images/Icon/svg/industryInfo/collected.svg';
import cooperation from '@/renderer/assets/images/Icon/svg/industryInfo/cooperation.svg';
import cooperationed from '@/renderer/assets/images/Icon/svg/industryInfo/cooperationed.svg';
import people from '@/renderer/assets/images/Icon/svg/industryInfo/people.svg';
import peopled from '@/renderer/assets/images/Icon/svg/industryInfo/peopled.svg';
import safe from '@/renderer/assets/images/Icon/svg/industryInfo/safe.svg';
import safed from '@/renderer/assets/images/Icon/svg/industryInfo/safed.svg';
import video1 from '@/renderer/assets/images/Icon/svg/industryInfo/video1.svg';
import video1ed from '@/renderer/assets/images/Icon/svg/industryInfo/video1ed.svg';

import {
  industryList,
  IndustryListType,
  adminCenterRouterList,
} from '@/renderer/components/dialog/IndustryInfo/config';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { openATagToDownloadUrl } from '@/renderer/scripts/utils/download/utils';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import user from '@/renderer/scripts/utils/user';
import { RoleMap } from '@/renderer/scripts/utils/ConstantConfig';
import { isTeamAdmin } from '@/renderer/scripts/utils/UserRole/getters';

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'general',
    },
  },
  components: { BaseIcon, QrcodeIcon, CloseIcon, ChevronRightIcon },
  setup(props, context) {
    const current = ref(1);
    let timer: number | undefined;
    const showPopup = ref(false);
    const { userRole } = user.getUserInfo();
    const currryIndustryInfo = computed((): IndustryListType => {
      const info = industryList.find(item => item.type === props.type);
      return info as IndustryListType;
    });

    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });

    const currentImgUrl = computed(() => {
      const { list } = currryIndustryInfo.value;
      return list.find(item => item.id === current.value)?.imgUrl;
    });

    const methods = {
      showLink(link: string) {
        if (!link) return false;
        if (adminCenterRouterList.includes(link)) {
          // 团队管理员部分也不可访问
          if (isTeamAdmin.value) {
            return !['securityScan'].includes(link);
          }
          // 普通成员
          return userRole !== RoleMap.User;
        }
        return true;
      },
      jumpToLink(link: string) {
        innerShow.value = false;
        setTimeout(() => {
          dispatchRouter({
            name: link,
          });
        }, 10);
      },
      change(id: number) {
        current.value = id;
        this.init();
      },
      init() {
        if (timer) {
          methods.clearTimer();
        }
        timer = window.setInterval(() => {
          if (current.value < 3) {
            current.value += 1;
          } else {
            methods.clearTimer();
          }
        }, 5000);
      },
      clearTimer() {
        window.clearInterval(timer);
        timer = undefined;
      },
      saveImg() {
        openATagToDownloadUrl(
          `${CONSTANT_URL.officialAccountWechat}?response-content-disposition=attachment`,
          'officialAccountWechat',
        );
      },
    };

    watch(
      () => props.show,
      val => {
        if (val) {
          current.value = 1;
          methods.init();
        } else {
          methods.clearTimer();
        }
      },
    );

    return {
      officialAccountWechat: CONSTANT_URL.officialAccountWechat,
      showPopup,
      currentImgUrl,
      current,
      innerShow,
      currryIndustryInfo,
      ...methods,

      approve,
      approved,
      book,
      booked,
      collect,
      collected,
      cooperation,
      cooperationed,
      people,
      peopled,
      safe,
      safed,
      video1,
      video1ed,
    };
  },
});
